import { apiGet } from './api';

export type DashOverview = {
  financeHidden: boolean;
  kpi: {
    portfolio: number | null;
    received: number | null;
    debitor: number | null;
    overdue: number | null;
    inProd: number;
    flags: number;
    active: number;
  };
  attention: { level: string; ico: string; title: string; text: string; dealId: number | null }[];
  cehLoad: { id: string; avg: number }[];
  charts: {
    months: { month: string; plan: number; fact: number; current: boolean }[];
    funnel: { stage: string; sum: number }[];
  };
};

export const dashOverview = () => apiGet<DashOverview>('/api/dash/overview');
